/* eslint algolia/no-module-exports: 0 */

import main from './src/lib/main.js';
module.exports = main;



/** WEBPACK FOOTER **
 ** ./index.js
 **/